import React, { useState } from 'react'
import { Button, Modal, Paper, Typography } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import { toastAlert } from '../../../utils/AlertContext';
import { getDeletePortadaURL } from "../../../utils/ConstantsURL";

export const DeleteModal = ({ token, open, onClose, idCover, refresh }) => {
  const [loading, setLoading] = useState(false);
  
  const handleDeletePortada = async () => {
    setLoading(true);
    try {
      const response = await fetch(getDeletePortadaURL(idCover), {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        toastAlert('Error al eliminar el portada', 'error');
        setLoading(false);
        return;
      }

      toastAlert('Portada eliminado correctamente', 'success');
      setLoading(false);
      onClose();
      refresh();
    } catch (error) {
      toastAlert('Error al eliminar el portada: ' + error, 'error');
      setLoading(false);
    }
  };

  return (
  <Modal open={open} onClose={onClose}>
    <Paper
      elevation={3}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        width: "300px",
        textAlign: "center",
      }}
    >
      <Typography variant="h6">
        ¿Estás seguro que deseas eliminar esta portada?
      </Typography>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button variant="outlined" onClick={onClose}>
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          color="secondary"
          onClick={handleDeletePortada}
          loading={loading}
        >
          Confirmar
        </LoadingButton>
      </div>
    </Paper>
  </Modal>
  );
};
